/* GG Wishlist.
 * Shared contract: localStorage "gg_wishlist" = array of product handle strings.
 * API on window.GGWish: toggle(handle) -> bool nowInList, has(handle), list(), count().
 * Dispatches 'gg-wish:change' on document after every mutation.
 * UI hooks: [data-gg-wish-count] badges, [data-gg-wish-toggle="<handle>"] buttons
 * (delegated, survive section re-render; active state = .is-wished + aria-pressed,
 * aria-label swapped from data-label-add / data-label-remove).
 * Logged-in sync: when the page contains [data-gg-wish-sync] (emitted only for
 * logged-in customers) every change POSTs the list (debounced 800ms) to
 * /apps/gg/wishlist — fire and forget, the backend may not be deployed yet.
 * Loaded once, deferred, from layout/theme.liquid.
 */
(function () {
  'use strict';

  var KEY = 'gg_wishlist';
  var syncTimer = null;

  function read() {
    try {
      var handles = JSON.parse(localStorage.getItem(KEY));
      if (!Array.isArray(handles)) return [];
      var seen = {};
      return handles.filter(function (h) {
        if (typeof h !== 'string' || !h || seen[h]) return false;
        seen[h] = true;
        return true;
      });
    } catch (e) {
      return [];
    }
  }

  function write(handles) {
    try {
      localStorage.setItem(KEY, JSON.stringify(handles));
    } catch (e) {
      /* storage blocked/full: wishlist lives only for this page */
    }
    document.dispatchEvent(new CustomEvent('gg-wish:change', { detail: { handles: handles } }));
  }

  var GGWish = {
    list: function () {
      return read();
    },
    count: function () {
      return read().length;
    },
    has: function (handle) {
      return read().indexOf(handle) !== -1;
    },
    toggle: function (handle) {
      if (!handle) return false;
      var handles = read();
      var i = handles.indexOf(handle);
      var nowInList;
      if (i === -1) {
        handles.push(handle);
        nowInList = true;
      } else {
        handles.splice(i, 1);
        nowInList = false;
      }
      write(handles);
      return nowInList;
    }
  };

  window.GGWish = GGWish;

  var lastSyncedBody = null;
  function scheduleSync() {
    if (!document.querySelector('[data-gg-wish-sync]')) return;
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      syncTimer = null;
      var body = JSON.stringify({ handles: GGWish.list() });
      if (body === lastSyncedBody) return; // dedupe: niente POST se la lista non è cambiata
      lastSyncedBody = body;
      fetch('/apps/gg/wishlist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body
      }).catch(function () {
        /* backend not deployed yet */
      });
    }, 800);
  }

  function refresh() {
    var handles = read();
    var n = handles.length;
    document.querySelectorAll('[data-gg-wish-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
    var inList = {};
    handles.forEach(function (h) {
      inList[h] = true;
    });
    document.querySelectorAll('[data-gg-wish-toggle]').forEach(function (btn) {
      var wished = !!inList[btn.getAttribute('data-gg-wish-toggle')];
      btn.classList.toggle('is-wished', wished);
      btn.setAttribute('aria-pressed', wished ? 'true' : 'false');
      var label = wished ? btn.getAttribute('data-label-remove') : btn.getAttribute('data-label-add');
      if (label) btn.setAttribute('aria-label', label);
    });
  }

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || !t.closest) return;
    var btn = t.closest('[data-gg-wish-toggle]');
    if (!btn) return;
    event.preventDefault();
    /* Wishlist dietro l'account come QF (G. 28/10): l'ospite salva il pezzo e va al login,
       poi torna sulla stessa pagina col pezzo già in lista. */
    if (!document.querySelector('[data-gg-wish-sync]')) {
      var handle = btn.getAttribute('data-gg-wish-toggle');
      if (!GGWish.has(handle)) GGWish.toggle(handle);
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      location.href = root + 'account/login?return_url=' + encodeURIComponent(location.pathname + location.search);
      return;
    }
    var nowInList = GGWish.toggle(btn.getAttribute('data-gg-wish-toggle'));
    /* Open the drawer after an ADD (never on remove), gated by the
       gg_wish_drawer_on_add setting emitted as data-open-on-add. */
    if (nowInList && window.GGWishDrawer) {
      var drawer = document.querySelector('[data-gg-wish-drawer]');
      if (drawer && drawer.getAttribute('data-open-on-add') === 'true') window.GGWishDrawer.open();
    }
  });

  document.addEventListener('gg-wish:change', function () {
    refresh();
    scheduleSync();
  });
  document.addEventListener('shopify:section:load', refresh);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
